var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeatLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2732 270.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.3;}.cls-2{fill:#657687;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-2",
    d: "M42.17,195.79A42.21,42.21,0,0,0,0,153.62v23.81a18.38,18.38,0,0,1,18.35,18.36A18.38,18.38,0,0,1,0,214.15V238a42.21,42.21,0,0,0,42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-2",
    d: "M42.83,228.25A42.23,42.23,0,0,0,.66,270.42H24.48a18.36,18.36,0,0,1,36.71,0H85a42.23,42.23,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-2",
    d: "M85.15,177.43V153.62a42.17,42.17,0,1,0,0,84.34h0V214.14a18.36,18.36,0,0,1,0-36.71"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2",
    "data-name": "Group 3-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-2",
    "data-name": "Path 1-2",
    className: "cls-2",
    d: "M725.17,195.79A42.21,42.21,0,0,0,683,153.62v23.81a18.36,18.36,0,0,1,0,36.72V238a42.21,42.21,0,0,0,42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-2",
    "data-name": "Path 2-2",
    className: "cls-2",
    d: "M725.83,228.25a42.23,42.23,0,0,0-42.17,42.17h23.82a18.36,18.36,0,0,1,36.71,0H768a42.23,42.23,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-2",
    "data-name": "Path 3-2",
    className: "cls-2",
    d: "M768.15,177.43V153.62a42.17,42.17,0,1,0,0,84.34h0V214.14a18.36,18.36,0,0,1,0-36.71"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-3",
    "data-name": "Group 3-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-3",
    "data-name": "Path 1-3",
    className: "cls-2",
    d: "M383.67,195.79a42.21,42.21,0,0,0-42.17-42.17v23.81a18.36,18.36,0,0,1,0,36.72V238a42.21,42.21,0,0,0,42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-3",
    "data-name": "Path 2-3",
    className: "cls-2",
    d: "M384.33,228.25a42.23,42.23,0,0,0-42.17,42.17H366a18.36,18.36,0,0,1,36.71,0h23.82a42.23,42.23,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-3",
    "data-name": "Path 3-3",
    className: "cls-2",
    d: "M426.65,177.43V153.62a42.17,42.17,0,1,0,0,84.34h0V214.14a18.36,18.36,0,0,1,0-36.71"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-4",
    "data-name": "Group 3-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-4",
    "data-name": "Path 1-4",
    className: "cls-2",
    d: "M1066.67,195.79a42.21,42.21,0,0,0-42.17-42.17v23.81a18.36,18.36,0,0,1,0,36.72V238a42.21,42.21,0,0,0,42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-4",
    "data-name": "Path 2-4",
    className: "cls-2",
    d: "M1067.33,228.25a42.23,42.23,0,0,0-42.17,42.17H1049a18.36,18.36,0,0,1,36.71,0h23.82a42.23,42.23,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-4",
    "data-name": "Path 3-4",
    className: "cls-2",
    d: "M1109.65,177.43V153.62a42.17,42.17,0,1,0,0,84.34h0V214.14a18.36,18.36,0,0,1,0-36.71"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-5",
    "data-name": "Group 3-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-5",
    "data-name": "Path 1-5",
    className: "cls-2",
    d: "M212.92,195.79a42.21,42.21,0,0,0-42.17-42.17v23.81a18.36,18.36,0,0,1,0,36.72V238a42.21,42.21,0,0,0,42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-5",
    "data-name": "Path 2-5",
    className: "cls-2",
    d: "M213.58,228.25a42.23,42.23,0,0,0-42.17,42.17h23.82a18.36,18.36,0,0,1,36.71,0h23.82a42.23,42.23,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-5",
    "data-name": "Path 3-5",
    className: "cls-2",
    d: "M255.9,177.43V153.62a42.17,42.17,0,1,0,0,84.34h0V214.14a18.36,18.36,0,0,1,0-36.71"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-6",
    "data-name": "Group 3-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-6",
    "data-name": "Path 1-6",
    className: "cls-2",
    d: "M895.92,195.79a42.21,42.21,0,0,0-42.17-42.17v23.81a18.36,18.36,0,0,1,0,36.72V238a42.21,42.21,0,0,0,42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-6",
    "data-name": "Path 2-6",
    className: "cls-2",
    d: "M896.58,228.25a42.23,42.23,0,0,0-42.17,42.17h23.82a18.36,18.36,0,0,1,36.71,0h23.82a42.23,42.23,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-6",
    "data-name": "Path 3-6",
    className: "cls-2",
    d: "M938.9,177.43V153.62a42.17,42.17,0,1,0,0,84.34h0V214.14a18.36,18.36,0,0,1,0-36.71"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-7",
    "data-name": "Group 3-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-7",
    "data-name": "Path 1-7",
    className: "cls-2",
    d: "M554.42,195.79a42.21,42.21,0,0,0-42.17-42.17v23.81a18.36,18.36,0,0,1,0,36.72V238a42.21,42.21,0,0,0,42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-7",
    "data-name": "Path 2-7",
    className: "cls-2",
    d: "M555.08,228.25a42.23,42.23,0,0,0-42.17,42.17h23.82a18.36,18.36,0,0,1,36.71,0h23.82a42.23,42.23,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-7",
    "data-name": "Path 3-7",
    className: "cls-2",
    d: "M597.4,177.43V153.62a42.17,42.17,0,1,0,0,84.34h0V214.14a18.36,18.36,0,0,1,0-36.71"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-8",
    "data-name": "Group 3-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-8",
    "data-name": "Path 1-8",
    className: "cls-2",
    d: "M1237.42,195.79a42.21,42.21,0,0,0-42.17-42.17v23.81a18.36,18.36,0,0,1,0,36.72V238a42.21,42.21,0,0,0,42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-8",
    "data-name": "Path 2-8",
    className: "cls-2",
    d: "M1238.08,228.25a42.23,42.23,0,0,0-42.17,42.17h23.82a18.36,18.36,0,0,1,36.71,0h23.82a42.23,42.23,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-8",
    "data-name": "Path 3-8",
    className: "cls-2",
    d: "M1280.4,177.43V153.62a42.17,42.17,0,1,0,0,84.34h0V214.14a18.36,18.36,0,0,1,0-36.71"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-9",
    "data-name": "Group 3-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-9",
    "data-name": "Path 1-9",
    className: "cls-2",
    d: "M127.77,159A42.21,42.21,0,0,0,85.6,116.81v23.82a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,127.77,159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-9",
    "data-name": "Path 2-9",
    className: "cls-2",
    d: "M128.43,191.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0H170.6a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-9",
    "data-name": "Path 3-9",
    className: "cls-2",
    d: "M170.75,140.63V116.81a42.17,42.17,0,1,0,0,84.34h0V177.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-10",
    "data-name": "Group 3-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-10",
    "data-name": "Path 1-10",
    className: "cls-2",
    d: "M810.77,159a42.21,42.21,0,0,0-42.17-42.17v23.82a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,810.77,159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-10",
    "data-name": "Path 2-10",
    className: "cls-2",
    d: "M811.43,191.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0H853.6a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-10",
    "data-name": "Path 3-10",
    className: "cls-2",
    d: "M853.75,140.63V116.81a42.17,42.17,0,1,0,0,84.34h0V177.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-11",
    "data-name": "Group 3-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-11",
    "data-name": "Path 1-11",
    className: "cls-2",
    d: "M469.27,159a42.21,42.21,0,0,0-42.17-42.17v23.82a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,469.27,159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-11",
    "data-name": "Path 2-11",
    className: "cls-2",
    d: "M469.93,191.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0H512.1a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-11",
    "data-name": "Path 3-11",
    className: "cls-2",
    d: "M512.25,140.63V116.81a42.17,42.17,0,1,0,0,84.34h0V177.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-12",
    "data-name": "Group 3-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-12",
    "data-name": "Path 1-12",
    className: "cls-2",
    d: "M1152.27,159a42.21,42.21,0,0,0-42.17-42.17v23.82a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,1152.27,159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-12",
    "data-name": "Path 2-12",
    className: "cls-2",
    d: "M1152.93,191.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-12",
    "data-name": "Path 3-12",
    className: "cls-2",
    d: "M1195.25,140.63V116.81a42.17,42.17,0,1,0,0,84.34h0V177.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-13",
    "data-name": "Group 3-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-13",
    "data-name": "Path 1-13",
    className: "cls-2",
    d: "M298.52,159a42.21,42.21,0,0,0-42.17-42.17v23.82a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,298.52,159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-13",
    "data-name": "Path 2-13",
    className: "cls-2",
    d: "M299.18,191.45A42.21,42.21,0,0,0,257,233.62h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-13",
    "data-name": "Path 3-13",
    className: "cls-2",
    d: "M341.5,140.63V116.81a42.17,42.17,0,1,0,0,84.34h0V177.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-14",
    "data-name": "Group 3-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-14",
    "data-name": "Path 1-14",
    className: "cls-2",
    d: "M981.52,159a42.21,42.21,0,0,0-42.17-42.17v23.82a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,981.52,159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-14",
    "data-name": "Path 2-14",
    className: "cls-2",
    d: "M982.18,191.45A42.21,42.21,0,0,0,940,233.62h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-14",
    "data-name": "Path 3-14",
    className: "cls-2",
    d: "M1024.5,140.63V116.81a42.17,42.17,0,1,0,0,84.34h0V177.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-15",
    "data-name": "Group 3-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-15",
    "data-name": "Path 1-15",
    className: "cls-2",
    d: "M640,159a42.21,42.21,0,0,0-42.17-42.17v23.82a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,640,159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-15",
    "data-name": "Path 2-15",
    className: "cls-2",
    d: "M640.68,191.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-15",
    "data-name": "Path 3-15",
    className: "cls-2",
    d: "M683,140.63V116.81a42.17,42.17,0,1,0,0,84.34h0V177.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-16",
    "data-name": "Group 3-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-16",
    "data-name": "Path 1-16",
    className: "cls-2",
    d: "M1323,159a42.21,42.21,0,0,0-42.17-42.17v23.82a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,1323,159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-16",
    "data-name": "Path 2-16",
    className: "cls-2",
    d: "M1323.68,191.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-16",
    "data-name": "Path 3-16",
    className: "cls-2",
    d: "M1366,140.63V116.81a42.17,42.17,0,1,0,0,84.34h0V177.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-17",
    "data-name": "Group 3-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-17",
    "data-name": "Path 1-17",
    className: "cls-2",
    d: "M42.17,79A42.21,42.21,0,0,0,0,36.81V60.63A18.37,18.37,0,0,1,18.35,79,18.37,18.37,0,0,1,0,97.34v23.82A42.22,42.22,0,0,0,42.17,79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-17",
    "data-name": "Path 2-17",
    className: "cls-2",
    d: "M42.83,111.45A42.21,42.21,0,0,0,.66,153.62H24.48a18.36,18.36,0,1,1,36.71,0H85a42.22,42.22,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-17",
    "data-name": "Path 3-17",
    className: "cls-2",
    d: "M85.15,60.63V36.81a42.17,42.17,0,1,0,0,84.34h0V97.34a18.36,18.36,0,0,1,0-36.71"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-18",
    "data-name": "Group 3-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-18",
    "data-name": "Path 1-18",
    className: "cls-2",
    d: "M725.17,79A42.21,42.21,0,0,0,683,36.81V60.63a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,725.17,79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-18",
    "data-name": "Path 2-18",
    className: "cls-2",
    d: "M725.83,111.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0H768a42.22,42.22,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-18",
    "data-name": "Path 3-18",
    className: "cls-2",
    d: "M768.15,60.63V36.81a42.17,42.17,0,1,0,0,84.34h0V97.34a18.36,18.36,0,0,1,0-36.71"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-19",
    "data-name": "Group 3-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-19",
    "data-name": "Path 1-19",
    className: "cls-2",
    d: "M383.67,79A42.21,42.21,0,0,0,341.5,36.81V60.63a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,383.67,79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-19",
    "data-name": "Path 2-19",
    className: "cls-2",
    d: "M384.33,111.45a42.21,42.21,0,0,0-42.17,42.17H366a18.36,18.36,0,1,1,36.71,0h23.82a42.22,42.22,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-19",
    "data-name": "Path 3-19",
    className: "cls-2",
    d: "M426.65,60.63V36.81a42.17,42.17,0,1,0,0,84.34h0V97.34a18.36,18.36,0,0,1,0-36.71"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-20",
    "data-name": "Group 3-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-20",
    "data-name": "Path 1-20",
    className: "cls-2",
    d: "M1066.67,79a42.21,42.21,0,0,0-42.17-42.17V60.63a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,1066.67,79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-20",
    "data-name": "Path 2-20",
    className: "cls-2",
    d: "M1067.33,111.45a42.21,42.21,0,0,0-42.17,42.17H1049a18.36,18.36,0,1,1,36.71,0h23.82a42.22,42.22,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-20",
    "data-name": "Path 3-20",
    className: "cls-2",
    d: "M1109.65,60.63V36.81a42.17,42.17,0,1,0,0,84.34h0V97.34a18.36,18.36,0,0,1,0-36.71"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-21",
    "data-name": "Group 3-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-21",
    "data-name": "Path 1-21",
    className: "cls-2",
    d: "M212.92,79a42.21,42.21,0,0,0-42.17-42.17V60.63a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,212.92,79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-21",
    "data-name": "Path 2-21",
    className: "cls-2",
    d: "M213.58,111.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.82a42.22,42.22,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-21",
    "data-name": "Path 3-21",
    className: "cls-2",
    d: "M255.9,60.63V36.81a42.17,42.17,0,1,0,0,84.34h0V97.34a18.36,18.36,0,0,1,0-36.71"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-22",
    "data-name": "Group 3-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-22",
    "data-name": "Path 1-22",
    className: "cls-2",
    d: "M895.92,79a42.21,42.21,0,0,0-42.17-42.17V60.63a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,895.92,79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-22",
    "data-name": "Path 2-22",
    className: "cls-2",
    d: "M896.58,111.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.82a42.22,42.22,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-22",
    "data-name": "Path 3-22",
    className: "cls-2",
    d: "M938.9,60.63V36.81a42.17,42.17,0,1,0,0,84.34h0V97.34a18.36,18.36,0,0,1,0-36.71"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-23",
    "data-name": "Group 3-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-23",
    "data-name": "Path 1-23",
    className: "cls-2",
    d: "M554.42,79a42.21,42.21,0,0,0-42.17-42.17V60.63a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,554.42,79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-23",
    "data-name": "Path 2-23",
    className: "cls-2",
    d: "M555.08,111.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.82a42.22,42.22,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-23",
    "data-name": "Path 3-23",
    className: "cls-2",
    d: "M597.4,60.63V36.81a42.17,42.17,0,1,0,0,84.34h0V97.34a18.36,18.36,0,0,1,0-36.71"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-24",
    "data-name": "Group 3-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-24",
    "data-name": "Path 1-24",
    className: "cls-2",
    d: "M1237.42,79a42.21,42.21,0,0,0-42.17-42.17V60.63a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,1237.42,79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-24",
    "data-name": "Path 2-24",
    className: "cls-2",
    d: "M1238.08,111.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.82a42.22,42.22,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-24",
    "data-name": "Path 3-24",
    className: "cls-2",
    d: "M1280.4,60.63V36.81a42.17,42.17,0,1,0,0,84.34h0V97.34a18.36,18.36,0,0,1,0-36.71"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-25",
    "data-name": "Group 3-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-25",
    "data-name": "Path 1-25",
    className: "cls-2",
    d: "M127.77,42.17A42.21,42.21,0,0,0,85.6,0V23.82a18.36,18.36,0,0,1,0,36.71V84.35a42.22,42.22,0,0,0,42.17-42.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-25",
    "data-name": "Path 2-25",
    className: "cls-2",
    d: "M128.43,74.64a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0H170.6a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-25",
    "data-name": "Path 3-25",
    className: "cls-2",
    d: "M170.75,23.82V0a42.18,42.18,0,0,0,0,84.35h0V60.53a18.36,18.36,0,1,1,0-36.71"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-26",
    "data-name": "Group 3-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-26",
    "data-name": "Path 1-26",
    className: "cls-2",
    d: "M810.77,42.17A42.21,42.21,0,0,0,768.6,0V23.82a18.36,18.36,0,0,1,0,36.71V84.35a42.22,42.22,0,0,0,42.17-42.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-26",
    "data-name": "Path 2-26",
    className: "cls-2",
    d: "M811.43,74.64a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0H853.6a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-26",
    "data-name": "Path 3-26",
    className: "cls-2",
    d: "M853.75,23.82V0a42.18,42.18,0,0,0,0,84.35h0V60.53a18.36,18.36,0,1,1,0-36.71"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-27",
    "data-name": "Group 3-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-27",
    "data-name": "Path 1-27",
    className: "cls-2",
    d: "M469.27,42.17A42.21,42.21,0,0,0,427.1,0V23.82a18.36,18.36,0,0,1,0,36.71V84.35a42.22,42.22,0,0,0,42.17-42.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-27",
    "data-name": "Path 2-27",
    className: "cls-2",
    d: "M469.93,74.64a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0H512.1a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-27",
    "data-name": "Path 3-27",
    className: "cls-2",
    d: "M512.25,23.82V0a42.18,42.18,0,0,0,0,84.35h0V60.53a18.36,18.36,0,1,1,0-36.71"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-28",
    "data-name": "Group 3-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-28",
    "data-name": "Path 1-28",
    className: "cls-2",
    d: "M1152.27,42.17A42.21,42.21,0,0,0,1110.1,0V23.82a18.36,18.36,0,0,1,0,36.71V84.35a42.22,42.22,0,0,0,42.17-42.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-28",
    "data-name": "Path 2-28",
    className: "cls-2",
    d: "M1152.93,74.64a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-28",
    "data-name": "Path 3-28",
    className: "cls-2",
    d: "M1195.25,23.82V0a42.18,42.18,0,0,0,0,84.35h0V60.53a18.36,18.36,0,1,1,0-36.71"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-29",
    "data-name": "Group 3-29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-29",
    "data-name": "Path 1-29",
    className: "cls-2",
    d: "M298.52,42.17A42.21,42.21,0,0,0,256.35,0V23.82a18.36,18.36,0,0,1,0,36.71V84.35a42.22,42.22,0,0,0,42.17-42.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-29",
    "data-name": "Path 2-29",
    className: "cls-2",
    d: "M299.18,74.64A42.21,42.21,0,0,0,257,116.81h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-29",
    "data-name": "Path 3-29",
    className: "cls-2",
    d: "M341.5,23.82V0a42.18,42.18,0,0,0,0,84.35h0V60.53a18.36,18.36,0,1,1,0-36.71"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-30",
    "data-name": "Group 3-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-30",
    "data-name": "Path 1-30",
    className: "cls-2",
    d: "M981.52,42.17A42.21,42.21,0,0,0,939.35,0V23.82a18.36,18.36,0,0,1,0,36.71V84.35a42.22,42.22,0,0,0,42.17-42.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-30",
    "data-name": "Path 2-30",
    className: "cls-2",
    d: "M982.18,74.64A42.21,42.21,0,0,0,940,116.81h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-30",
    "data-name": "Path 3-30",
    className: "cls-2",
    d: "M1024.5,23.82V0a42.18,42.18,0,0,0,0,84.35h0V60.53a18.36,18.36,0,1,1,0-36.71"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-31",
    "data-name": "Group 3-31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-31",
    "data-name": "Path 1-31",
    className: "cls-2",
    d: "M640,42.17A42.21,42.21,0,0,0,597.85,0V23.82a18.36,18.36,0,0,1,0,36.71V84.35A42.22,42.22,0,0,0,640,42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-31",
    "data-name": "Path 2-31",
    className: "cls-2",
    d: "M640.68,74.64a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-31",
    "data-name": "Path 3-31",
    className: "cls-2",
    d: "M683,23.82V0a42.18,42.18,0,0,0,0,84.35h0V60.53a18.36,18.36,0,1,1,0-36.71"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-32",
    "data-name": "Group 3-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-32",
    "data-name": "Path 1-32",
    className: "cls-2",
    d: "M1323,42.17A42.21,42.21,0,0,0,1280.85,0V23.82a18.36,18.36,0,0,1,0,36.71V84.35A42.22,42.22,0,0,0,1323,42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-32",
    "data-name": "Path 2-32",
    className: "cls-2",
    d: "M1323.68,74.64a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-32",
    "data-name": "Path 3-32",
    className: "cls-2",
    d: "M1366,23.82V0a42.18,42.18,0,0,0,0,84.35h0V60.53a18.36,18.36,0,1,1,0-36.71"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_32-2",
    "data-name": "Group 32",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2-2",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-2-2",
    "data-name": "Path 1",
    className: "cls-2",
    d: "M1408.17,195.79A42.21,42.21,0,0,0,1366,153.62v23.81a18.36,18.36,0,0,1,0,36.72V238a42.21,42.21,0,0,0,42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-2-2",
    "data-name": "Path 2",
    className: "cls-2",
    d: "M1408.83,228.25a42.23,42.23,0,0,0-42.17,42.17h23.82a18.36,18.36,0,0,1,36.71,0H1451a42.23,42.23,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-2-2",
    "data-name": "Path 3",
    className: "cls-2",
    d: "M1451.15,177.43V153.62a42.17,42.17,0,1,0,0,84.34h0V214.14a18.36,18.36,0,1,1,0-36.71"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_62-2",
    "data-name": "Group 62",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2-3",
    "data-name": "Group 3-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-2-3",
    "data-name": "Path 1-2",
    className: "cls-2",
    d: "M2091.17,195.79A42.21,42.21,0,0,0,2049,153.62v23.81a18.36,18.36,0,0,1,0,36.72V238a42.21,42.21,0,0,0,42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-2-3",
    "data-name": "Path 2-2",
    className: "cls-2",
    d: "M2091.83,228.25a42.23,42.23,0,0,0-42.17,42.17h23.82a18.36,18.36,0,0,1,36.71,0H2134a42.23,42.23,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-2-3",
    "data-name": "Path 3-2",
    className: "cls-2",
    d: "M2134.15,177.43V153.62a42.17,42.17,0,0,0,0,84.34h0V214.14a18.36,18.36,0,1,1,0-36.71"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47-2",
    "data-name": "Group 47",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-3-2",
    "data-name": "Group 3-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-3-2",
    "data-name": "Path 1-3",
    className: "cls-2",
    d: "M1749.67,195.79a42.21,42.21,0,0,0-42.17-42.17v23.81a18.36,18.36,0,0,1,0,36.72V238a42.21,42.21,0,0,0,42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-3-2",
    "data-name": "Path 2-3",
    className: "cls-2",
    d: "M1750.33,228.25a42.23,42.23,0,0,0-42.17,42.17H1732a18.36,18.36,0,0,1,36.71,0h23.82a42.23,42.23,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-3-2",
    "data-name": "Path 3-3",
    className: "cls-2",
    d: "M1792.65,177.43V153.62a42.17,42.17,0,1,0,0,84.34h0V214.14a18.36,18.36,0,1,1,0-36.71"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_49-2",
    "data-name": "Group 49",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-4-2",
    "data-name": "Group 3-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-4-2",
    "data-name": "Path 1-4",
    className: "cls-2",
    d: "M2432.67,195.79a42.21,42.21,0,0,0-42.17-42.17v23.81a18.36,18.36,0,0,1,0,36.72V238a42.21,42.21,0,0,0,42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-4-2",
    "data-name": "Path 2-4",
    className: "cls-2",
    d: "M2433.33,228.25a42.23,42.23,0,0,0-42.17,42.17H2415a18.36,18.36,0,0,1,36.71,0h23.82a42.23,42.23,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-4-2",
    "data-name": "Path 3-4",
    className: "cls-2",
    d: "M2475.65,177.43V153.62a42.17,42.17,0,1,0,0,84.34h0V214.14a18.36,18.36,0,1,1,0-36.71"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39-2",
    "data-name": "Group 39",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-5-2",
    "data-name": "Group 3-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-5-2",
    "data-name": "Path 1-5",
    className: "cls-2",
    d: "M1578.92,195.79a42.21,42.21,0,0,0-42.17-42.17v23.81a18.36,18.36,0,0,1,0,36.72V238a42.21,42.21,0,0,0,42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-5-2",
    "data-name": "Path 2-5",
    className: "cls-2",
    d: "M1579.58,228.25a42.23,42.23,0,0,0-42.17,42.17h23.82a18.36,18.36,0,0,1,36.71,0h23.82a42.23,42.23,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-5-2",
    "data-name": "Path 3-5",
    className: "cls-2",
    d: "M1621.9,177.43V153.62a42.17,42.17,0,1,0,0,84.34h0V214.14a18.36,18.36,0,1,1,0-36.71"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_55-2",
    "data-name": "Group 55",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-6-2",
    "data-name": "Group 3-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-6-2",
    "data-name": "Path 1-6",
    className: "cls-2",
    d: "M2261.92,195.79a42.21,42.21,0,0,0-42.17-42.17v23.81a18.36,18.36,0,0,1,0,36.72V238a42.21,42.21,0,0,0,42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-6-2",
    "data-name": "Path 2-6",
    className: "cls-2",
    d: "M2262.58,228.25a42.23,42.23,0,0,0-42.17,42.17h23.82a18.36,18.36,0,0,1,36.71,0h23.82a42.23,42.23,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-6-2",
    "data-name": "Path 3-6",
    className: "cls-2",
    d: "M2304.9,177.43V153.62a42.17,42.17,0,1,0,0,84.34h0V214.14a18.36,18.36,0,1,1,0-36.71"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_43-2",
    "data-name": "Group 43",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-7-2",
    "data-name": "Group 3-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-7-2",
    "data-name": "Path 1-7",
    className: "cls-2",
    d: "M1920.42,195.79a42.21,42.21,0,0,0-42.17-42.17v23.81a18.36,18.36,0,0,1,0,36.72V238a42.21,42.21,0,0,0,42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-7-2",
    "data-name": "Path 2-7",
    className: "cls-2",
    d: "M1921.08,228.25a42.23,42.23,0,0,0-42.17,42.17h23.82a18.36,18.36,0,0,1,36.71,0h23.82a42.23,42.23,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-7-2",
    "data-name": "Path 3-7",
    className: "cls-2",
    d: "M1963.4,177.43V153.62a42.17,42.17,0,1,0,0,84.34h0V214.14a18.36,18.36,0,1,1,0-36.71"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48-2",
    "data-name": "Group 48",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-8-2",
    "data-name": "Group 3-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-8-2",
    "data-name": "Path 1-8",
    className: "cls-2",
    d: "M2603.42,195.79a42.21,42.21,0,0,0-42.17-42.17v23.81a18.36,18.36,0,0,1,0,36.72V238a42.21,42.21,0,0,0,42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-8-2",
    "data-name": "Path 2-8",
    className: "cls-2",
    d: "M2604.08,228.25a42.23,42.23,0,0,0-42.17,42.17h23.82a18.36,18.36,0,0,1,36.71,0h23.82a42.23,42.23,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-8-2",
    "data-name": "Path 3-8",
    className: "cls-2",
    d: "M2646.4,177.43V153.62a42.17,42.17,0,1,0,0,84.34h0V214.14a18.36,18.36,0,1,1,0-36.71"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_34-2",
    "data-name": "Group 34",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-9-2",
    "data-name": "Group 3-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-9-2",
    "data-name": "Path 1-9",
    className: "cls-2",
    d: "M1493.77,159a42.22,42.22,0,0,0-42.17-42.17v23.82a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,1493.77,159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-9-2",
    "data-name": "Path 2-9",
    className: "cls-2",
    d: "M1494.43,191.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-9-2",
    "data-name": "Path 3-9",
    className: "cls-2",
    d: "M1536.75,140.63V116.81a42.17,42.17,0,1,0,0,84.34h0V177.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_60-2",
    "data-name": "Group 60",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-10-2",
    "data-name": "Group 3-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-10-2",
    "data-name": "Path 1-10",
    className: "cls-2",
    d: "M2176.77,159a42.22,42.22,0,0,0-42.17-42.17v23.82a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,2176.77,159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-10-2",
    "data-name": "Path 2-10",
    className: "cls-2",
    d: "M2177.43,191.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-10-2",
    "data-name": "Path 3-10",
    className: "cls-2",
    d: "M2219.75,140.63V116.81a42.17,42.17,0,0,0,0,84.34h0V177.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_44-2",
    "data-name": "Group 44",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-11-2",
    "data-name": "Group 3-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-11-2",
    "data-name": "Path 1-11",
    className: "cls-2",
    d: "M1835.27,159a42.22,42.22,0,0,0-42.17-42.17v23.82a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,1835.27,159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-11-2",
    "data-name": "Path 2-11",
    className: "cls-2",
    d: "M1835.93,191.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-11-2",
    "data-name": "Path 3-11",
    className: "cls-2",
    d: "M1878.25,140.63V116.81a42.17,42.17,0,1,0,0,84.34h0V177.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_50-2",
    "data-name": "Group 50",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-12-2",
    "data-name": "Group 3-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-12-2",
    "data-name": "Path 1-12",
    className: "cls-2",
    d: "M2518.27,159a42.22,42.22,0,0,0-42.17-42.17v23.82a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,2518.27,159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-12-2",
    "data-name": "Path 2-12",
    className: "cls-2",
    d: "M2518.93,191.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-12-2",
    "data-name": "Path 3-12",
    className: "cls-2",
    d: "M2561.25,140.63V116.81a42.17,42.17,0,0,0,0,84.34h0V177.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37-2",
    "data-name": "Group 37",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-13-2",
    "data-name": "Group 3-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-13-2",
    "data-name": "Path 1-13",
    className: "cls-2",
    d: "M1664.52,159a42.22,42.22,0,0,0-42.17-42.17v23.82a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,1664.52,159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-13-2",
    "data-name": "Path 2-13",
    className: "cls-2",
    d: "M1665.18,191.45A42.21,42.21,0,0,0,1623,233.62h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-13-2",
    "data-name": "Path 3-13",
    className: "cls-2",
    d: "M1707.5,140.63V116.81a42.17,42.17,0,1,0,0,84.34h0V177.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_51-2",
    "data-name": "Group 51",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-14-2",
    "data-name": "Group 3-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-14-2",
    "data-name": "Path 1-14",
    className: "cls-2",
    d: "M2347.52,159a42.22,42.22,0,0,0-42.17-42.17v23.82a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,2347.52,159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-14-2",
    "data-name": "Path 2-14",
    className: "cls-2",
    d: "M2348.18,191.45A42.21,42.21,0,0,0,2306,233.62h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-14-2",
    "data-name": "Path 3-14",
    className: "cls-2",
    d: "M2390.5,140.63V116.81a42.17,42.17,0,0,0,0,84.34h0V177.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41-2",
    "data-name": "Group 41",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-15-2",
    "data-name": "Group 3-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-15-2",
    "data-name": "Path 1-15",
    className: "cls-2",
    d: "M2006,159a42.22,42.22,0,0,0-42.17-42.17v23.82a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,2006,159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-15-2",
    "data-name": "Path 2-15",
    className: "cls-2",
    d: "M2006.68,191.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-15-2",
    "data-name": "Path 3-15",
    className: "cls-2",
    d: "M2049,140.63V116.81a42.17,42.17,0,1,0,0,84.34h0V177.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_52-2",
    "data-name": "Group 52",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-16-2",
    "data-name": "Group 3-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-16-2",
    "data-name": "Path 1-16",
    className: "cls-2",
    d: "M2689,159a42.22,42.22,0,0,0-42.17-42.17v23.82a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,2689,159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-16-2",
    "data-name": "Path 2-16",
    className: "cls-2",
    d: "M2689.68,191.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-16-2",
    "data-name": "Path 3-16",
    className: "cls-2",
    d: "M2732,140.63V116.81a42.17,42.17,0,0,0,0,84.34h0V177.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Group_33-2",
    "data-name": "Group 33",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-17-2",
    "data-name": "Group 3-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-17-2",
    "data-name": "Path 1-17",
    className: "cls-2",
    d: "M1408.17,79A42.21,42.21,0,0,0,1366,36.81V60.63a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,1408.17,79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-17-2",
    "data-name": "Path 2-17",
    className: "cls-2",
    d: "M1408.83,111.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0H1451a42.22,42.22,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-17-2",
    "data-name": "Path 3-17",
    className: "cls-2",
    d: "M1451.15,60.63V36.81a42.17,42.17,0,1,0,0,84.34h0V97.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63-2",
    "data-name": "Group 63",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-18-2",
    "data-name": "Group 3-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-18-2",
    "data-name": "Path 1-18",
    className: "cls-2",
    d: "M2091.17,79A42.21,42.21,0,0,0,2049,36.81V60.63a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,2091.17,79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-18-2",
    "data-name": "Path 2-18",
    className: "cls-2",
    d: "M2091.83,111.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0H2134a42.22,42.22,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-18-2",
    "data-name": "Path 3-18",
    className: "cls-2",
    d: "M2134.15,60.63V36.81a42.17,42.17,0,1,0,0,84.34h0V97.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46-2",
    "data-name": "Group 46",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-19-2",
    "data-name": "Group 3-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-19-2",
    "data-name": "Path 1-19",
    className: "cls-2",
    d: "M1749.67,79a42.21,42.21,0,0,0-42.17-42.17V60.63a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,1749.67,79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-19-2",
    "data-name": "Path 2-19",
    className: "cls-2",
    d: "M1750.33,111.45a42.21,42.21,0,0,0-42.17,42.17H1732a18.36,18.36,0,1,1,36.71,0h23.82a42.22,42.22,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-19-2",
    "data-name": "Path 3-19",
    className: "cls-2",
    d: "M1792.65,60.63V36.81a42.17,42.17,0,1,0,0,84.34h0V97.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Group_53-2",
    "data-name": "Group 53",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-20-2",
    "data-name": "Group 3-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-20-2",
    "data-name": "Path 1-20",
    className: "cls-2",
    d: "M2432.67,79a42.21,42.21,0,0,0-42.17-42.17V60.63a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,2432.67,79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-20-2",
    "data-name": "Path 2-20",
    className: "cls-2",
    d: "M2433.33,111.45a42.21,42.21,0,0,0-42.17,42.17H2415a18.36,18.36,0,1,1,36.71,0h23.82a42.22,42.22,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-20-2",
    "data-name": "Path 3-20",
    className: "cls-2",
    d: "M2475.65,60.63V36.81a42.17,42.17,0,1,0,0,84.34h0V97.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Group_36-2",
    "data-name": "Group 36",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-21-2",
    "data-name": "Group 3-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-21-2",
    "data-name": "Path 1-21",
    className: "cls-2",
    d: "M1578.92,79a42.21,42.21,0,0,0-42.17-42.17V60.63a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,1578.92,79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-21-2",
    "data-name": "Path 2-21",
    className: "cls-2",
    d: "M1579.58,111.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.82a42.22,42.22,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-21-2",
    "data-name": "Path 3-21",
    className: "cls-2",
    d: "M1621.9,60.63V36.81a42.17,42.17,0,1,0,0,84.34h0V97.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Group_56-2",
    "data-name": "Group 56",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-22-2",
    "data-name": "Group 3-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-22-2",
    "data-name": "Path 1-22",
    className: "cls-2",
    d: "M2261.92,79a42.21,42.21,0,0,0-42.17-42.17V60.63a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,2261.92,79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-22-2",
    "data-name": "Path 2-22",
    className: "cls-2",
    d: "M2262.58,111.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.82a42.22,42.22,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-22-2",
    "data-name": "Path 3-22",
    className: "cls-2",
    d: "M2304.9,60.63V36.81a42.17,42.17,0,1,0,0,84.34h0V97.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40-2",
    "data-name": "Group 40",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-23-2",
    "data-name": "Group 3-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-23-2",
    "data-name": "Path 1-23",
    className: "cls-2",
    d: "M1920.42,79a42.21,42.21,0,0,0-42.17-42.17V60.63a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,1920.42,79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-23-2",
    "data-name": "Path 2-23",
    className: "cls-2",
    d: "M1921.08,111.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.82a42.22,42.22,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-23-2",
    "data-name": "Path 3-23",
    className: "cls-2",
    d: "M1963.4,60.63V36.81a42.17,42.17,0,1,0,0,84.34h0V97.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Group_54-2",
    "data-name": "Group 54",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-24-2",
    "data-name": "Group 3-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-24-2",
    "data-name": "Path 1-24",
    className: "cls-2",
    d: "M2603.42,79a42.21,42.21,0,0,0-42.17-42.17V60.63a18.36,18.36,0,0,1,0,36.71v23.82A42.22,42.22,0,0,0,2603.42,79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-24-2",
    "data-name": "Path 2-24",
    className: "cls-2",
    d: "M2604.08,111.45a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.82a42.22,42.22,0,0,0-42.18-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-24-2",
    "data-name": "Path 3-24",
    className: "cls-2",
    d: "M2646.4,60.63V36.81a42.17,42.17,0,1,0,0,84.34h0V97.34a18.36,18.36,0,1,1,0-36.71"
  })))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35-2",
    "data-name": "Group 35",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-25-2",
    "data-name": "Group 3-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-25-2",
    "data-name": "Path 1-25",
    className: "cls-2",
    d: "M1493.77,42.17A42.22,42.22,0,0,0,1451.6,0V23.82a18.36,18.36,0,0,1,0,36.71V84.35a42.22,42.22,0,0,0,42.17-42.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-25-2",
    "data-name": "Path 2-25",
    className: "cls-2",
    d: "M1494.43,74.64a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-25-2",
    "data-name": "Path 3-25",
    className: "cls-2",
    d: "M1536.75,23.82V0a42.18,42.18,0,0,0,0,84.35h0V60.53a18.36,18.36,0,1,1,0-36.71"
  })))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Group_61-2",
    "data-name": "Group 61",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-26-2",
    "data-name": "Group 3-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-26-2",
    "data-name": "Path 1-26",
    className: "cls-2",
    d: "M2176.77,42.17A42.22,42.22,0,0,0,2134.6,0V23.82a18.36,18.36,0,0,1,0,36.71V84.35a42.22,42.22,0,0,0,42.17-42.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-26-2",
    "data-name": "Path 2-26",
    className: "cls-2",
    d: "M2177.43,74.64a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-26-2",
    "data-name": "Path 3-26",
    className: "cls-2",
    d: "M2219.75,23.82V0a42.18,42.18,0,0,0,0,84.35h0V60.53a18.36,18.36,0,1,1,0-36.71"
  })))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Group_45-2",
    "data-name": "Group 45",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-27-2",
    "data-name": "Group 3-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-27-2",
    "data-name": "Path 1-27",
    className: "cls-2",
    d: "M1835.27,42.17A42.22,42.22,0,0,0,1793.1,0V23.82a18.36,18.36,0,0,1,0,36.71V84.35a42.22,42.22,0,0,0,42.17-42.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-27-2",
    "data-name": "Path 2-27",
    className: "cls-2",
    d: "M1835.93,74.64a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-27-2",
    "data-name": "Path 3-27",
    className: "cls-2",
    d: "M1878.25,23.82V0a42.18,42.18,0,0,0,0,84.35h0V60.53a18.36,18.36,0,1,1,0-36.71"
  })))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Group_57-2",
    "data-name": "Group 57",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-28-2",
    "data-name": "Group 3-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-28-2",
    "data-name": "Path 1-28",
    className: "cls-2",
    d: "M2518.27,42.17A42.22,42.22,0,0,0,2476.1,0V23.82a18.36,18.36,0,0,1,0,36.71V84.35a42.22,42.22,0,0,0,42.17-42.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-28-2",
    "data-name": "Path 2-28",
    className: "cls-2",
    d: "M2518.93,74.64a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-28-2",
    "data-name": "Path 3-28",
    className: "cls-2",
    d: "M2561.25,23.82V0a42.18,42.18,0,0,0,0,84.35h0V60.53a18.36,18.36,0,1,1,0-36.71"
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Group_38-2",
    "data-name": "Group 38",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-29-2",
    "data-name": "Group 3-29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-29-2",
    "data-name": "Path 1-29",
    className: "cls-2",
    d: "M1664.52,42.17A42.22,42.22,0,0,0,1622.35,0V23.82a18.36,18.36,0,0,1,0,36.71V84.35a42.22,42.22,0,0,0,42.17-42.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-29-2",
    "data-name": "Path 2-29",
    className: "cls-2",
    d: "M1665.18,74.64A42.21,42.21,0,0,0,1623,116.81h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-29-2",
    "data-name": "Path 3-29",
    className: "cls-2",
    d: "M1707.5,23.82V0a42.18,42.18,0,0,0,0,84.35h0V60.53a18.36,18.36,0,1,1,0-36.71"
  })))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Group_58-2",
    "data-name": "Group 58",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-30-2",
    "data-name": "Group 3-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-30-2",
    "data-name": "Path 1-30",
    className: "cls-2",
    d: "M2347.52,42.17A42.22,42.22,0,0,0,2305.35,0V23.82a18.36,18.36,0,0,1,0,36.71V84.35a42.22,42.22,0,0,0,42.17-42.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-30-2",
    "data-name": "Path 2-30",
    className: "cls-2",
    d: "M2348.18,74.64A42.21,42.21,0,0,0,2306,116.81h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-30-2",
    "data-name": "Path 3-30",
    className: "cls-2",
    d: "M2390.5,23.82V0a42.18,42.18,0,0,0,0,84.35h0V60.53a18.36,18.36,0,1,1,0-36.71"
  })))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Group_42-2",
    "data-name": "Group 42",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-31-2",
    "data-name": "Group 3-31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-31-2",
    "data-name": "Path 1-31",
    className: "cls-2",
    d: "M2006,42.17A42.22,42.22,0,0,0,1963.85,0V23.82a18.36,18.36,0,0,1,0,36.71V84.35A42.22,42.22,0,0,0,2006,42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-31-2",
    "data-name": "Path 2-31",
    className: "cls-2",
    d: "M2006.68,74.64a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-31-2",
    "data-name": "Path 3-31",
    className: "cls-2",
    d: "M2049,23.82V0a42.18,42.18,0,0,0,0,84.35h0V60.53a18.36,18.36,0,1,1,0-36.71"
  })))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Group_59-2",
    "data-name": "Group 59",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-32-2",
    "data-name": "Group 3-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-32-2",
    "data-name": "Path 1-32",
    className: "cls-2",
    d: "M2689,42.17A42.22,42.22,0,0,0,2646.85,0V23.82a18.36,18.36,0,0,1,0,36.71V84.35A42.22,42.22,0,0,0,2689,42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-32-2",
    "data-name": "Path 2-32",
    className: "cls-2",
    d: "M2689.68,74.64a42.21,42.21,0,0,0-42.17,42.17h23.82a18.36,18.36,0,1,1,36.71,0h23.81a42.21,42.21,0,0,0-42.17-42.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3-32-2",
    "data-name": "Path 3-32",
    className: "cls-2",
    d: "M2732,23.82V0a42.18,42.18,0,0,0,0,84.35h0V60.53a18.36,18.36,0,1,1,0-36.71"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatLogo);
export default __webpack_public_path__ + "static/media/repeat-logo.d0dc60311f5f852387ea6f7767045d7e.svg";
export { ForwardRef as ReactComponent };